import { createFileRoute } from "@tanstack/react-router";
import { DashboardLayout } from "@/projects/components/dashboard-layout";
import { useSubmissions, useAuth } from "@/projects/lib/useStore";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/projects/components/ui/table";
import { StatusBadge } from "@/projects/components/status-badge";

export const Route = createFileRoute("/teacher/history")({
  head: () => ({ meta: [{ title: "Verification History — Teacher" }] }),
  component: () => {
    const auth = useAuth();
    const all = useSubmissions();
    const mine = all.filter((s) => s.assignedTeacherId === auth?.id && (s.status === "Ready for Reward" || s.status === "Not Proper"));
    return (
      <DashboardLayout role="teacher" title="Verification History" breadcrumb={["Home", "History"]}>
        <div className="overflow-hidden rounded-xl border bg-card shadow-soft">
          <Table>
            <TableHeader>
              <TableRow className="bg-muted/50">
                <TableHead>Reference</TableHead>
                <TableHead>Student</TableHead>
                <TableHead>Title</TableHead>
                <TableHead>Status</TableHead>
                <TableHead>Verified</TableHead>
                <TableHead>Remarks</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {mine.length === 0 && <TableRow><TableCell colSpan={6} className="py-10 text-center text-sm text-muted-foreground">No verification history yet.</TableCell></TableRow>}
              {mine.map((s) => (
                <TableRow key={s.id}>
                  <TableCell className="font-mono text-xs text-royal">{s.id}</TableCell>
                  <TableCell>{s.studentName}</TableCell>
                  <TableCell className="max-w-[220px] truncate">{s.videoTitle}</TableCell>
                  <TableCell><StatusBadge status={s.status} /></TableCell>
                  <TableCell className="text-xs text-muted-foreground">{s.verifiedAt && new Date(s.verifiedAt).toLocaleString()}</TableCell>
                  <TableCell className="max-w-[280px] text-xs">{s.teacherRemarks}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </DashboardLayout>
    );
  },
});
